export default __webpack_public_path__ + "static/media/Dosen-dark.9aa04b53.svg";